import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../store/hooks";
import { NotificationInterface, setEditId, setEditError, selectNotificationById } from "../../../store/mine_craft/notificationsSlice";
import { updateNotification, fetchNotification } from "../../../actions/mine_craft/notificationsActions";
import { objToFormData } from "../../../helpers/FormHelper";

import DrawerRight from "../../../componets/DrawerRight";
import Form from './_partials/_Form';
import AlertBlock from "../../../componets/AlertBlock";

const Edit = () => {
  const dispatch      = useAppDispatch();
  const id: any       = useAppSelector(state => state.mineCraft.notifications.editId);
  const error         = useAppSelector(state => state.mineCraft.notifications.editError);
  const notification  = useAppSelector(state => selectNotificationById(state, id));

  useEffect(() => {
    if (id) {
      dispatch(fetchNotification(id));
    }
  }, [id, dispatch]);

  function onCloseError() {
    dispatch(setEditError(null));
  }

  function onClose() {
    dispatch(setEditId(null));
  }

  function onFinish(data: NotificationInterface) {
    handleSave(data).catch(console.error);
  }

  async function handleSave(data: NotificationInterface) {
    const formData = objToFormData(data);
    const resultAction = await dispatch(updateNotification({ id, data: formData }));

    if (updateNotification.fulfilled.match(resultAction)) {
      onClose();
    }
  }

  return (
    <DrawerRight
      open={!!id}
      onClose={onClose}
      getContainer='.v-layout--body'
    >
      <div className='v-edit-notification'>
        <h6 className="v-content-label">Edit Notification</h6>

        <AlertBlock type='error' message={error} onClose={onCloseError} />

        { notification && <Form params={notification} onFinish={onFinish} /> }
      </div>
    </DrawerRight>
  )
}

export default Edit;
